export type AppTabId = "feed" | "explore" | "live" | "community" | "profile";

export const appTabs = [
  { id: "feed" as AppTabId, label: "Inicio", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill" },
  { id: "explore" as AppTabId, label: "Explorar", icon: "ri-compass-3-line", activeIcon: "ri-compass-3-fill" },
  { id: "live" as AppTabId, label: "En Vivo", icon: "ri-live-line", activeIcon: "ri-live-fill" },
  { id: "community" as AppTabId, label: "Comunidad", icon: "ri-group-line", activeIcon: "ri-group-fill" },
  { id: "profile" as AppTabId, label: "Perfil", icon: "ri-user-3-line", activeIcon: "ri-user-3-fill" },
];

interface AppBottomNavProps {
  activeTab: AppTabId;
  onTabChange: (tab: AppTabId) => void;
}

export default function AppBottomNav({ activeTab, onTabChange }: AppBottomNavProps) {
  return (
    <nav className="w-full bg-background-50/98 backdrop-blur-2xl border-t border-background-200 safe-bottom shrink-0">
      <div className="flex items-center justify-around h-[56px] px-1">
        {appTabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`relative flex flex-col items-center justify-center gap-0.5 h-full min-w-0 flex-1 transition-all duration-200 cursor-pointer ${
                isActive ? "text-primary-500" : "text-foreground-400 hover:text-foreground-600"
              }`}
            >
              {isActive && (
                <div className="absolute top-0 left-1/4 right-1/4 h-0.5 bg-primary-500 rounded-full"></div>
              )}
              <div className={`w-6 h-6 flex items-center justify-center ${isActive ? "scale-110" : ""} transition-transform duration-200`}>
                <i className={`${isActive ? tab.activeIcon : tab.icon} text-lg`}></i>
              </div>
              <span className={`text-[10px] font-semibold whitespace-nowrap ${isActive ? "opacity-100" : "opacity-70"}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}